<div class="edit-title-dialog">
	<h2>{{ 'edit_title' | translate }}</h2>
	<div>
		<form-field-label labelTranslateKey="title" />
		<mat-form-field appearance="outline" class="full-width">
			<input matInput [formControl]="titleControl" [maxlength]="maxLength" />
			<mat-hint align="end">{{ currentLength$ | async }} / {{ maxLength }}</mat-hint>
			<mat-hint align="start"> *{{ 'obligatory' | translate }} </mat-hint>
		</mat-form-field>
	</div>

	<div class="actions">
		<button mat-button [mat-dialog-close]="null">
			{{ 'cancel' | translate }}
		</button>
		<button
			mat-flat-button
			class="tonal-flat-button"
			[disabled]="titleControl.invalid"
			[mat-dialog-close]="titleControl.value"
		>
			{{ 'save' | translate }}
		</button>
	</div>
</div>
